import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import { roundTo2 } from '../../../utils/numbers';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getRoundedRectanglePath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// "ACI" text generated with text-to-svg and Century Gothic bold
// see https://ipfabric.atlassian.net/wiki/spaces/devOps/pages/1623457793/Snippets#Generate-svg-path-from-text%2Ffont

const ACI_TEXT_PATH =
  'M.0239 1.0059L.3008 .2876L.4395 .2876L.7158 1.0059L.5737 1.0059L.5176 .8579L.2246 .8579L.166 1.0059L.0239 1.0059ZM.4663 .7246L.3711 .478L.2754 .7246L.4663 .7246ZM1.4819 .4141L1.4819 .4141L1.3862 .5054Q1.2886 .4023 1.1665 .4023L1.1665 .4023Q1.0635 .4023 .9929 .4727Q.9224 .543 .9224 .646L.9224 .646Q.9224 .7178 .9536 .7734Q.9849 .8291 1.042 .8608Q1.0991 .8926 1.1689 .8926L1.1689 .8926Q1.2285 .8926 1.2778 .8704Q1.3271 .8481 1.3862 .7896L1.3862 .7896L1.479 .8862Q1.3994 .9639 1.3286 .9939Q1.2578 1.0239 1.167 1.0239L1.167 1.0239Q.9995 1.0239 .8928 .9177Q.7861 .8115 .7861 .6455L.7861 .6455Q.7861 .5381 .8347 .4546Q.8833 .3711 .9739 .3203Q1.0645 .2695 1.1689 .2695L1.1689 .2695Q1.2578 .2695 1.3401 .3071Q1.4224 .3447 1.4819 .4141ZM1.5918 1.0059L1.5918 .2876L1.7275 .2876L1.7275 1.0059L1.5918 1.0059Z';
const FONT_SIZE = 11.2;
const ACI_TEXT_WIDTH = 1.8;

/** shared with aciSpine icon */
export const drawAciGlyph = (offsetY: number): string => `
  ${makeTag('path', {
    d: ACI_TEXT_PATH,
    /* horizontally "almost" centered - shifted 0.4 to left as it looks better with asymmetric arrows around */
    transform: `translate(${roundTo2(19.6 - (FONT_SIZE * ACI_TEXT_WIDTH) / 2)} ${roundTo2(4.4 + offsetY)}) scale(${FONT_SIZE})`,
    fill: ICON_DEFAULT_FOREGROUND_COLOR,
  })}
  ${makeTag('path', {
    d: `${getRoundedRectanglePath(
      5.2,
      1.2 + offsetY,
      29.6,
      21.6,
      2.4,
    )}${new SvgPathBuilder()
      .moveTo(2.4, 5.6 + offsetY)
      .lineTo(5.2, 8.4 + offsetY)
      .lineTo(8, 5.6 + offsetY)
      .moveTo(32, 18.4 + offsetY)
      .lineTo(34.8, 15.6 + offsetY)
      .lineTo(37.6, 18.4 + offsetY)
      .build()}`,
    fill: 'none',
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 1.8,
    'stroke-linecap': 'round',
  })}
`;

function createAciLeafIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${drawAciGlyph(8)}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const aciLeafIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAciLeafIcon,
);
